import {Router} from '@angular/router';
import {Component} from '@angular/core';
import {LoginService} from './login.service';
import {CookiesManager} from '../../core/cookies';
import {SessionService} from '../../core/security';
import {HashUtils} from '../../../../common/utils';
import {ErrorResponse} from '../../../../common/providers';

@Component({
    selector: 'login',
    providers: [LoginService],
    template: require('./login.template.html')
})
export class LoginComponent {

    model: any = {
        login: '',
        password: ''
    };

    message: string = null;
    loading: boolean = false;
    showLogoutMessage: boolean = false;
    showExpiredMessage: boolean = false;

    constructor(private router: Router,
                private _loginService: LoginService,
                private _sessionService: SessionService) {
    }

    ngOnInit() {
        if (CookiesManager.isTokenExist()) {
            this.router.navigate(['space']);
        }

        this.showLogoutMessage = this._sessionService.isSessionLogout();
        this.showExpiredMessage = this._sessionService.isSessionExpired();
        this._sessionService.clearSessionCloseReason();
    }

    submit(event) {
        event.preventDefault();

        this.message = null;
        this.loading = true;

        this._loginService
            .login(this.getCredentials())
            .subscribe(
                (session: {token: string, expires: number}) => this.successLogin(session),
                (error) => this.failureLogin(error)
            );
    }

    hasMessage(): boolean {
        return this.message !== null;
    }

    private successLogin(session: {token: string, expires: number}) {
        this._sessionService.login(session);
    }

    private failureLogin(error: ErrorResponse) {
        this.message = error.message;
        this.loading = false;
    }

    private getCredentials() {
        return Object.assign({}, this.model, {password: HashUtils.sha512(this.model.password)});
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/login/login.component.ts